import fullscreenDialogManager from '../fullscreen/fullscreen-dialog-manager'
import sendMessageToSidebar from './send-message-to-sidebar'

// Host-context pushes (item open/data/change, post-send) go to every portal instance:
// the docked sidebar and, while the fullscreen Office Dialog is open, the popout too
// (PENG-803). Request/reply callbacks stay sidebar-only via sendMessageToSidebar.
export default function broadcastMessageToPortals(messageType: string, args: any) {
  sendMessageToSidebar(messageType, args)
  fullscreenDialogManager.sendToDialog(messageType, args)
}
